import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../api/axios";
import ProductList from "../components/ProductList";

const CategoryPage = () => {
  const { categoryName } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcat, setSelectedSubcat] = useState("Todos");

  useEffect(() => {
    const fetchCategoryProducts = async () => {
      try {
        setLoading(true);
        // Llama al endpoint de productos de la categoría
        const { data } = await API.get(`/products/category/${encodeURIComponent(categoryName)}`);
        setProducts(data);
        setLoading(false);

        // Extraer subcategorías únicas (excluyendo valores falsy)
        const distinctSubs = [...new Set(data.map((p) => p.subcategory).filter(Boolean))];
        setSubcategories(distinctSubs);
      } catch (error) {
        console.error("Error obteniendo productos de la categoría:", error);
        setLoading(false);
      }
    };

    fetchCategoryProducts();
  }, [categoryName]);

  // Filtrar productos según la subcategoría seleccionada
  const displayedProducts =
    selectedSubcat === "Todos" ? products : products.filter((p) => p.subcategory === selectedSubcat);

  return (
    <div className="container mx-auto mt-10 px-4">
      {/* Banner de la categoría */}
      <div
        className="relative w-full h-64 bg-cover bg-center"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_BACKEND_URL}/uploads/categoryImage/${categoryName.toLowerCase().replace(/\s+/g, "-")}.jpg)`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <h1 className="relative text-white text-4xl font-bold text-center pt-24">{categoryName}</h1>
      </div>

      {/* Botones de subcategorías */}
      <h2 className="text-2xl font-bold text-center my-6">Subcategorías</h2>
      <div className="flex justify-center gap-4 mb-6">
        <button
          onClick={() => setSelectedSubcat("Todos")}
          className={`px-4 py-2 rounded ${selectedSubcat === "Todos" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
        >
          Todos
        </button>
        {subcategories.map((sub) => (
          <button
            key={sub}
            onClick={() => setSelectedSubcat(sub)}
            className={`px-4 py-2 rounded ${selectedSubcat === sub ? "bg-blue-600 text-white" : "bg-gray-200"}`}
          >
            {sub}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-center text-gray-500">⏳ Cargando productos...</p>
      ) : displayedProducts.length > 0 ? (
        <ProductList products={displayedProducts} />
      ) : (
        <p className="text-center">No hay productos disponibles para esta subcategoría.</p>
      )}
    </div>
  );
};

export default CategoryPage;
